@if (hasAccess) {
  <div class="padding">
    <h1 class="left-box">{{user?.lastName ?? ""}}, {{user?.firstName ?? ""}} {{user?.middleName ?? ""}}</h1>
    <mat-card>
      @if (user != null) {
        <mat-card-content>
          <div class="flex-container padding-top">
            <div class="flex-item form-field">
              <mat-radio-group [(ngModel)]="this.user.userTypeID" [attr.aria-label]="'common.labels.apiOrPortalUserRadioButtons' | transloco">
                <mat-radio-button class="radio-button" [value]="apiUserType" (change)="onUserTypeSelectionChange($event)">{{ 'common.labels.api' | transloco }}</mat-radio-button>
                <mat-radio-button class="radio-button" [value]="portalUserType" (change)="onUserTypeSelectionChange($event)">{{ 'common.labels.clientPortal' | transloco }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          @if (shouldShowTwoFactor) {
            <div class="flex-container padding">
              <div class="flex-item form-field">
                <mat-slide-toggle [(ngModel)]="user!.isTwoFactorEnabled">{{ 'common.labels.multiFactorAuthentication' | transloco }}</mat-slide-toggle>
                @if (!userDidLoadWithTwoFactorEnabled && user!.isTwoFactorEnabled) {
                  <div class="list-container validation-problems notices">
                    {{ 'common.labels.aQrCodeForMultiFactor' | transloco }}
                  </div>
                }
              </div>
            </div>
          }
          <div class="flex-container">
            <mat-form-field appearance="outline" class="flex-item">
              <mat-label>{{ 'common.labels.username' | transloco }}</mat-label>
              <input matInput name="username" disabled="true" [(ngModel)]="this.user.userName" [placeholder]="'common.labels.username' | transloco">
            </mat-form-field>
            <mat-checkbox [(ngModel)]="this.user!.isActive" class="checkbox form-field">{{ 'common.labels.active' | transloco }}</mat-checkbox>
          </div>
          <div class="flex-container">
            <mat-form-field appearance="outline" class="flex-item">
              <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
              <input matInput name="firstName"[(ngModel)]="this.user.firstName" [placeholder]="'common.labels.firstName' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="flex-item">
              <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
              <input matInput name="middleName"[(ngModel)]="this.user.middleName" [placeholder]="'common.labels.middleName' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="flex-item">
              <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
              <input matInput name="lastName"[(ngModel)]="this.user.lastName" [placeholder]="'common.labels.lastName' | transloco">
            </mat-form-field>
          </div>
          <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.configuration' | transloco }}</mat-label>
              <mat-select name="configuration" [(ngModel)]="this.user!.configurationDetailsID">
                @for (configuration of configurationDetailsOptions; track configuration) {
                  <mat-option [value]="configuration.id">
                    {{configuration.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <h3>{{ 'common.labels.contactInformation' | transloco }}</h3>
          @if (user != null) {
            <app-client-contact-details-card [contactDetails]="user!.contactDetails"></app-client-contact-details-card>
          }
          <div class="flex-container">
            <span class="spacer"></span>
            <button mat-raised-button (click)="updateUserDetails()" color="accent" class="apply-padding" [attr.aria-label]="'management.updateUserButton' | transloco">
              {{ 'management.saveChanges' | transloco }}
            </button>
          </div>
        </mat-card-content>
      }
    </mat-card>
  </div>
}